import React from 'react';
import { debounce } from 'lodash';
import { TextField } from '@fluentui/react';
import InfoTooltip from '../../formFields/InfoTooltip';

const TextFilter = ({fieldName, onChange, fieldLabel, tooltip}) =>  {
    
    const onChangeDebounced = debounce(value => {
        onChange(fieldName, value.toLowerCase().trim());
    }, 500);

    const onRenderLabel = ({label, id}) => {
        const tooltipControl = tooltip && <InfoTooltip content={tooltip} />
        return <label htmlFor={id} style={labelStyles} className='ms-Label'>Search by {fieldLabel}{tooltipControl}</label>
    }

    return (
        <div>
            <TextField
                onRenderLabel={onRenderLabel}
                onChange={(e, val) => onChangeDebounced(val)}
                id={`search-${fieldName}`}
                type="text-box"
                autoComplete="off"
                name={fieldName}
            />
        </div>
    );
}

const labelStyles = {
    display: 'block',
    padding: '5px 0'
}

export default TextFilter


// WEBPACK FOOTER //
// ./src/components/Administration/Filters/TextFilter.js